import { MouseEvent, useEffect, useState } from 'react'

import { useModal } from 'hooks/useModal'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import styles from './bankAccount.module.scss'

const side = {
  bride: '신부측',
  groom: '신랑측',
}

type Side = typeof side[keyof typeof side]

interface Account {
  person: string
  name: string
  bank: string
  account: string
}

const accounts: Record<keyof typeof side, Account[]> = {
  groom: [
    {
      person: '신랑',
      name: '임 율',
      bank: '카카오뱅크',
      account: '3333255612267',
    },
    {
      person: '신랑 어머니',
      name: '김영순',
      bank: '신협',
      account: '137-003-447470',
    },
  ],
  bride: [
    {
      person: '신부',
      name: '박진희',
      bank: '신한',
      account: '110550343081',
    },
    {
      person: '신부 어머니',
      name: '옥은숙',
      bank: '신협',
      account: '132-030-674913',
    },
  ],
}

const BankAccount = () => {
  const [selectedSide, setSelectedSide] = useState<Side>(side.groom)
  const [copiedPerson, setCopiedPerson] = useState('')
  const { isModalOpen, openModal, closeModal } = useModal()

  useEffect(() => {
    return () => setCopiedPerson('')
  }, [isModalOpen])

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    setSelectedSide((e.target as HTMLButtonElement).value as Side)
    openModal()
  }

  const handleCopy = (e: MouseEvent<HTMLButtonElement>) => {
    const { id, value } = e.target as HTMLButtonElement
    navigator.clipboard.writeText(value)
    setCopiedPerson(id)
  }

  return (
    <section>
      <h2 style={{ color: '#812808' }}>마음 전하실 곳</h2>
      <div className={styles.buttonWrapper}>
        <Button
          text={side.groom}
          value={side.groom}
          size='fullWidth'
          buttonStyle='secondary'
          className={`${styles.customButton} ${styles.groomButton}`}
          onClick={handleClick}
        />
        <Button
          text={side.bride}
          value={side.bride}
          size='fullWidth'
          buttonStyle='secondary'
          className={`${styles.customButton} ${styles.brideButton}`}
          onClick={handleClick}
        />
      </div>
      <p>멀리서도 축하의 마음을 전하고 싶은 분들을 위해 안내드립니다.</p>
      <p>소중한 축하를 보내주셔서 감사드립니다.</p>
      {/* <p>* 화환은 정중히 사양합니다.</p> */}
      {isModalOpen && (
        <Modal title={selectedSide === side.groom ? side.groom : side.bride} closeModal={closeModal}>
          {accounts[selectedSide === side.groom ? 'groom' : 'bride'].map((account) => (
            <div key={account.name} className={styles.accountItem}>
              <div>
                <div>
                  {account.person} <span>{account.name}</span>
                </div>
                <div className={styles.account}>
                  {account.bank} {account.account}
                </div>
              </div>
              {account.name === copiedPerson ? (
                <CheckIcon />
              ) : (
                <Button
                  id={account.name}
                  text='복사'
                  value={`${account.bank} ${account.account}`}
                  size='small'
                  buttonStyle='ghost'
                  onClick={handleCopy}
                />
              )}
            </div>
          ))}
        </Modal>
      )}
    </section>
  )
}

export default BankAccount
